import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GraduationCap, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent } from "@/components/ui/dialog";

// Einmaliger Willkommens-Hinweis für Creator beim allerersten Login.
export function OnboardingWelcome() {
  const { user, reload } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  const show = user && user.role === "creator" && !user.onboarding_seen && !dismissed;
  if (!show) return null;

  const markSeen = () => {
    setDismissed(true);
    api.post("/auth/onboarding-seen").then(() => reload()).catch(() => {});
  };

  const goOnboarding = () => {
    markSeen();
    navigate("/handbuch");
  };

  return (
    <Dialog open onOpenChange={(o) => { if (!o) markSeen(); }}>
      <DialogContent data-testid="onboarding-welcome" className="max-w-md text-center">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-neutral-900 text-white flex items-center justify-center">
          <GraduationCap className="h-7 w-7" />
        </div>
        <h2 className="font-head font-bold text-xl text-neutral-900 mt-2">
          Willkommen im Team, {user.name?.split(" ")[0] || "Creator"}! 👋
        </h2>
        <p className="text-sm text-neutral-500 leading-relaxed">
          Neu hier? Unser Onboarding zeigt dir in 15 Minuten, wie das Board funktioniert —
          vom ersten Thema bis zum fertigen Reel. Danach bist du startklar.
        </p>
        <div className="flex flex-col gap-2 mt-2">
          <button
            data-testid="onboarding-start-btn"
            onClick={goOnboarding}
            className="w-full inline-flex items-center justify-center gap-2 bg-neutral-900 text-white text-sm font-semibold px-4 py-3 rounded-lg hover:bg-neutral-800"
          >
            <Sparkles className="h-4 w-4 text-fuchsia-400" /> Onboarding starten
          </button>
          <button
            data-testid="onboarding-skip-btn"
            onClick={markSeen}
            className="w-full text-sm font-medium text-neutral-500 hover:text-neutral-800 py-2"
          >
            Später selbst erkunden
          </button>
        </div>
        <p className="text-[11px] text-neutral-400">Du findest das Handbuch jederzeit links im Menü.</p>
      </DialogContent>
    </Dialog>
  );
}
